<template>
    <b-container fluid class="div-background">
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
        <b-alert
            :show="messageObject.success.count"
            dismissible
            @dismissed="messageObject.success.count = 0"
            @dismiss-count-down="successCountChanged"
            >{{ messageObject.success.content }}
        </b-alert>
        <b-row align-h="center">
            <b-col md="5" class="setdivheight">
                <h2>領取禮物</h2>
                <b-alert show variant="warning">
                    <h4 class="alert-heading">注意!!</h4>
                    <hr>
                    <p class="alert-text">
                        此畫面請轉給人員確認後操作，自行操作將無法領取禮物。
                    </p>
                </b-alert>
                <b-button @click="callModal" block size="lg" variant="primary"
                    >確定領取</b-button
                >
                </b-col>
            </b-row>
            <b-modal
                id="modal-changepassword"
                ref="showmodal"
                title="確認領取?"
                @show="resetModal"
                @hidden="resetModal"
                @ok="handleOk"
            >
                確定要領取?
            </b-modal>
    </b-container>
</template>
<script>
export default {
    data(){
        return {
            dismissSecs: 3,
            breadcrumbItems: [
                {
                text: "首頁",
                href: "#",
                },
                {
                text: "小禮物領取",
                active: true,
                },
            ],
            messageObject: {
                success: {
                //show: false,
                content: null,
                count: 0,
                },
                dismissSecs: 3,
            },
            apiUpdataGetGift: (data) =>
                this.userRequest.post("API/Default/UpdataGetGift", data),
        }
    },
    methods:{
        callModal(){
            this.$refs["showmodal"].show();
        },
        resetModal() {
            this.$refs["showmodal"].hide();
        },
        handleOk() {
            this.FunctionToken(this.UpdataGetGift,{});
        },
        suceessPopUp(msg) {
            this.messageObject.success.count = this.dismissSecs;
            this.messageObject.success.content = msg;
        },
        successCountChanged(count) {
            this.messageObject.success.count = count;
        },
        UpdataGetGift(data){
            this.apiUpdataGetGift(data)
                .then((res) =>{
                    console.log(res)
                    let json = JSON.parse(res.data);
                    if(json.Status){
                        sessionStorage.removeItem("getGift");
                        this.cangetGeft= false;
                        this.suceessPopUp("領取成功，即將進行轉跳")
                        setTimeout(function () {
                            //window.location.assign("http://localhost:8080/#/myprefecture");
                            window.location.assign("https://agri-data.cyhg.gov.tw/#/myprefecture");
                            window.location.reload();
                        }, 3000)
                    }
                })
        }
    }
}
</script>
<style scoped>
.alert-heading{
    font-size: 36px;
    font-weight: bolder;
}
.alert-text{
    font-size: 24px;
}
</style>